/**
 * SuperMemo-2 (SM-2) Spaced Repetition Algorithm
 * Quality: 0–5 (e.g. Don't Know → 1, Know → 4)
 */

export interface SM2Result {
  repetitionCount: number;
  easinessFactor: number;
  intervalDays: number;
  nextReviewDate: Date;
}

/**
 * Calculate updated SM-2 values after a review.
 *
 * @param quality - Grade 0–5 (0–2: incorrect, 3–5: correct)
 * @param repetition - Current repetition count (0-based)
 * @param easinessFactor - Current easiness factor
 * @param interval - Current interval in days
 * @returns Updated SM-2 values and next review date
 */
export function calculateSM2(
  quality: number,
  repetition: number,
  easinessFactor: number,
  interval: number
): SM2Result {
  let newRepetition: number;
  let newInterval: number;
  let newEasinessFactor: number;

  if (quality >= 3) {
    // Correct answer
    newRepetition = repetition + 1;

    if (repetition === 0) {
      newInterval = 1;
    } else if (repetition === 1) {
      newInterval = 6;
    } else {
      newInterval = Math.round(interval * easinessFactor);
    }

    newEasinessFactor =
      easinessFactor +
      (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02));
    newEasinessFactor = Math.max(newEasinessFactor, 1.3);
  } else {
    // Incorrect answer — reset
    newRepetition = 0;
    newInterval = 1;
    newEasinessFactor = easinessFactor;
  }

  const nextReviewDate = new Date();
  nextReviewDate.setDate(nextReviewDate.getDate() + newInterval);

  return {
    repetitionCount: newRepetition,
    easinessFactor: newEasinessFactor,
    intervalDays: newInterval,
    nextReviewDate,
  };
}
